type ModalHelperReturnType = {
  title: string;
  subtitle?: string;
  glyph:
    | 'create-project-thin'
    | 'create-project'
    | 'import-project'
    | 'clone-project';
  onBackClick?: () => void;
};

type ModalHelperType = {
  selectedTypeProject: string;
  onGoBack: () => void;
};

const modalHelper = ({
  onGoBack,
  selectedTypeProject,
}: ModalHelperType): ModalHelperReturnType => {
  let setup: ModalHelperReturnType = {
    title: 'Create Project',
    glyph: 'create-project-thin',
  };
  switch (selectedTypeProject) {
    case 'create-project':
      setup = {
        ...setup,
        title: 'New Project',
        subtitle:
          'Create your own project from scratch and customise it as you like!',
        glyph: 'create-project',
        onBackClick: onGoBack,
      };
      break;
    case 'import-project':
      setup = {
        ...setup,
        title: 'Import Project',
        subtitle: 'Import the project that you want to work with',
        glyph: 'import-project',
        onBackClick: onGoBack,
      };
      break;
    case 'clone-project':
      setup = {
        ...setup,
        title: 'Clone Organization Project',
        subtitle:
          'Clone one of your teammates project and build your own copy.',
        glyph: 'clone-project',
        onBackClick: onGoBack,
      };
      break;
    default:
      break;
  }

  return setup;
};

export default modalHelper;
